import React, { useContext, useEffect, useRef, useState } from "react";
import { GrFormNext } from "react-icons/gr";
import { GrFormPrevious } from "react-icons/gr";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ThemeContext } from "../context/themeContext";

export default function Gallery({ imgMockup, selectedProject, img, proje }) {
  gsap.registerPlugin(useGSAP);

  const [currentIndex, setCurrentIndex] = useState(1);
  const [direction, setDirection] = useState("next");

  const { darkTheme } = useContext(ThemeContext);

  const gallery = useRef();

  const handlePrevious = () => {
    setDirection("previous");

    if (currentIndex > 1) {
      setCurrentIndex(currentIndex - 1);
    } else return;
  };

  const handleNext = () => {
    setDirection("next");
    if (currentIndex < imgMockup.length) {
      setCurrentIndex(currentIndex + 1);
    } else return;
  };

  useGSAP(
    () => {
      if(!selectedProject) return
      console.log(direction);
      console.log(`#imgBox${currentIndex}`);

      if (direction === "next") {
        gsap.fromTo(
          `#imgBox${currentIndex}`,
          {
            xPercent: 50,
            opacity: 0,
          },
          {
            xPercent: 0,
            opacity: 1,
            duration: 0.2,
          },
        );
        gsap.to(`#imgBox${currentIndex - 1}`, {
          xPercent: -50,
          opacity: 0,
          duration: 0.2,
        });
      } else {
        gsap.fromTo(
          `#imgBox${currentIndex}`,
          {
            xPercent: -50,
            opacity: 0,
          },
          {
            xPercent: 0,
            opacity: 1,
            duration: 0.2,
          },
        );
        gsap.to(`#imgBox${currentIndex + 1}`, {
          xPercent: 50,
          opacity: 0,
          duration: 0.2,
        });
      }
      gsap.to(`#bullet${currentIndex}`, {
        background: darkTheme ? "#f5f5f5" : "#222",
      });
      gsap.to(`.bullet:not(#bullet${currentIndex})`, {
        background: "transparent",
      });
    },
    { dependencies: [currentIndex, darkTheme], scope: gallery },
  );

  useGSAP(
    () => {
      if (selectedProject) {
        imgMockup.map((item, index) => {
          gsap.to(`.project.selected .right #imgBox${index + 1}`, {
            backgroundImage:
              item.includes(".mp4") || item.includes("webm")
                ? "none"
                : `url(${item})`,
          });
        });
      } else {
        gsap.to(`.project.selected .right .imgBox`, {
          backgroundImage: `url(${img})`,
        });
      }
    },
    { dependencies: selectedProject },
  );

  // console.log(currentIndex);
  // console.log(imgMockup);

  return (
    <div className="gallery-container" ref={gallery}>
      <div
        id={`gallery-${selectedProject}`}
        className={`${direction} gallery`}
        style={{ background: "none" }}
      >
        {imgMockup && imgMockup.length > 1 && (
          <div className="galleryButtons">
            <div
              className={`hover-target previousButton ${currentIndex == 1 ? "hide" : ""}`}
              onClick={() => handlePrevious()}
            >
              <GrFormPrevious className="hover-target"/>
            </div>
            <div
              className={`hover-target nextButton ${currentIndex >= imgMockup.length ? "hide" : ""}`}
              onClick={() => handleNext()}
            >
              <GrFormNext className="hover-target"/>
            </div>
          </div>
        )}
        {selectedProject ? (
          imgMockup.map((item, index) => {
            return (
              <div
                id={`imgBox${index + 1}`}
                className={`imgBox ${index + 1 == currentIndex ? "currentImg" : ""}`}
              >
                {selectedProject &&
                  (item.includes(".webm") || item.includes(".mp4")) && (
                    <video autoPlay loop muted src="" style={{ width: "100%" }}>
                      <source src={item} type="video/mp4" />
                    </video>
                  )}
              </div>
            );
          })
        ) : (
          <div
            className="imgBox"
            style={{ backgroundImage: `url("${img}")` }}
          ></div>
        )}
      </div>
      {imgMockup && imgMockup.length > 1 && (
        <div className="bullets">
          {imgMockup.map((item, index) => {
            return (
              <div
                className={`bullet ${(index + 1) == currentIndex ? "current" : ""}`}
                id={`bullet${index + 1}`}
                onClick={() => setCurrentIndex(index + 1)}
              ></div>
            );
          })}
        </div>
      )}
    </div>
  );
}
